export default {
    export: 'تصدير',
    'print-material-statement': 'طباعة كشف مادة',
    'export-as-excel': 'تصدير إكسل',
    'material-name-or-num': 'رقم أو اسم المادة',
    'from-date': 'من تاريخ',
    'to-date': 'إلى تاريخ',
    'refresh': 'تحديث',
    'go-to-the-journal-entry': 'الانتقال إلى اليومية الخاصة بالقيد',
    'final-balance': 'الرصيد النهائي:',
    'total-incoming-quantity': 'مجموع الكمية الداخلة:',
    'total-outcoming-quantity': 'مجموع الكمية الخارجة:',
    'delivery-statuses' : 'حالات التسليم',
    'show-material-status-footer': 'إظهار تفاصيل الكميات',

    headers: {
        'balance': 'الرصيد',
        'income-quantity': 'كمية داخلة',
        'outcome-quantity': 'كمية خارجة',
        'count': 'العدد',
        'note': 'الشرح',
        'date': 'التاريخ',
        'price': 'السعر',
        'document-no': 'المستند',
        'materials-journal-balance': 'ر.يومية المواد',
        'invoice-balance': 'ر.الفاتورة',
        'sequence': 'التسلسل',
        'account': 'الحساب',
        'child-material': 'اسم المادة',
        'delivery-status': 'حالة التسليم'
    }
}